module.exports = __webpack_public_path__ + "static/img/home_buffer_photo4@2x.e801741.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productCase/home_buffer_photo4@2x.png
// module id = FsRY
// module chunks = 0